import IconRu from '@/assets/images/langs/iconRu.png';
import IconEn from '@/assets/images/langs/iconEn.png';
import IconAm from '@/assets/images/langs/iconAm.png';

export default {
  localeModel: {
    loading: false,
    instance: {},
  },

  localeList: {
    loading: true,
    instance: [
      {
        icon: IconRu,
        value: 'ru',
        label: 'Русский',
        shortLabel: 'Рус',
      },
      {
        icon: IconAm,
        value: 'hy',
        label: 'հայերեն',
        shortLabel: 'հայ',
      },
      {
        icon: IconEn,
        value: 'en',
        label: 'English',
        shortLabel: 'Eng',
      },
    ],
  },
};
